import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import getCategories from 'store/app/selector/getCategories';
import getOpRoutes from 'store/app/selector/getOpRoutes';
import { Category } from 'store/app/types';
import getCurrentRoute from 'utils/getCurrentRoute';

const useActiveRoute = () => {
  const router = useRouteMatch();
  const categories = useSelector(getCategories) || [];
  const opRoutes = useSelector(getOpRoutes);

  return getCurrentRoute(router.path, categories as Category[], opRoutes);
};

export default useActiveRoute;
